import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { DashboardModalActions } from '@carvana/purchase-helpers';
import { purchaseEditOrderRouteWhitelist } from '@carvana/purchase-utils';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import * as AppActions from '../../ducks/actions';
import * as sc from './edit-order-modal.styles';

const EditOrderModal = props => {
  const { schedule: { deliveryPreference }, modalProps: { editCoBuyer } = {} } = props;
  const [, , route] = window.location.pathname.split('/');
  const { trackEvent } = useContext(AnalyticsContext);
  const redirectToPurchaseProcess = coBuyerEdit => window.location.href = coBuyerEdit ? '/procurement/payment-options?personal-details=1' : '/procurement';
  const deliveryOrPickup = deliveryPreference.toLowerCase().includes('delivery') ? 'delivery' : 'pickup';
  const isOrderPlaced = route === 'order-placed';

  const confirmEditOrder = () => {
    trackEvent('v2_opd_edit_order_button_tap');
    if (purchaseEditOrderRouteWhitelist.includes(route)) trackEvent('v2_finalize_purchase_edit_button_clicked');
    DashboardModalActions.ShowModalLoadingSpinner();
    AppActions.EditOrder({ cancelTransfer: true }).then(() => DashboardModalActions.CloseModal(false, { closeModalCallback: redirectToPurchaseProcess(editCoBuyer) }));
  };

  return (
    <sc.ContentWrapper>
      <sc.AlertIcon />
      {isOrderPlaced
        ? <>
            <sc.BoldText>This will release your {deliveryOrPickup} date</sc.BoldText>
            <sc.BodyText>
              Editing your order will release your {deliveryOrPickup} appointment and <b>your vehicle will become available for others to purchase if you don't schedule a new appointment before the timer expires</b>
            </sc.BodyText>
          </>
        : editCoBuyer
          ? <sc.BoldText>Are you sure you want to edit your co-signer's email?</sc.BoldText>
          : <>
              <sc.BoldText>Are you sure you want to edit your order?</sc.BoldText>
              <sc.BodyText>
                You will have a limited time to make your changes, otherwise your vehicle will become unlocked and available for others to purchase.
              </sc.BodyText>
            </>
      }
      <sc.ButtonWrapper>
        <sc.ConfirmButton onClick={confirmEditOrder}>
          {isOrderPlaced ? 'Release delivery date' : 'Yes, edit'}
        </sc.ConfirmButton>
        <sc.CancelButton onClick={DashboardModalActions.CloseModal}>
          {isOrderPlaced ? 'Go back' : 'No, go back'}
        </sc.CancelButton>
      </sc.ButtonWrapper>
    </sc.ContentWrapper>
  );
};

EditOrderModal.propTypes = {
  schedule: PropTypes.shape({}).isRequired,
  modalProps: PropTypes.shape({
    editCoBuyer: PropTypes.bool
  }).isRequired
};

EditOrderModal.defaultProps = {};

export default EditOrderModal;
